import { useConfig } from '@atlassiansox/bxp-content-framework';
export const useSignupUrl = ({ confirmReturnUrl, email, prompt, returnUrl } = {}) => {
    const { environment } = useConfig();
    const isProduction = environment === 'production';
    const baseUrl = isProduction
        ? 'id.atlassian.com'
        : 'id.stg.internal.atlassian.com';
    const host = isProduction ? 'trello.com' : 'trellis.coffee';
    // Param passed twice to Identity (in primary URL and encoded in continue/callback URL)
    // See https://hello.atlassian.net/browse/BXPT-1348?focusedCommentId=8509655
    const display = 'eyJ2ZXJpZmljYXRpb25TdHJhdGVneSI6InNvZnQifQ==';
    const continueParams = new URLSearchParams({ display });
    if (returnUrl) {
        continueParams.append('returnUrl', returnUrl);
    }
    if (confirmReturnUrl) {
        continueParams.append('confirmReturnUrl', confirmReturnUrl);
    }
    const params = new URLSearchParams({
        application: 'trello',
        continue: `https://${host}/auth/atlassian/callback?${continueParams}`,
        display
    });
    if (email) {
        params.append('email', email);
    }
    if (prompt) {
        params.append('prompt', prompt);
    }
    return `https://${baseUrl}/signup?${params}`;
};
//# sourceMappingURL=use-signup-url.js.map